<template>
  <div class="layout-navbar-topMenu">
    <div class="right-menu flex-row align-center">
      <!-- 通知 -->
      <i v-if="tabularFault" class="el-icon-message-solid" @click="notificationAnnouncement" />
      <!-- 日志 -->
      <error-log v-if="log.length" class="errLog-container" :logs-list="log" />

      <!-- <div class="right-menu-btn flex-row align-center justify-center">
        <svg-icon icon-class="navbar-todo-tasks" />
        <span>待办任务</span>
      </div> -->

      <el-badge :value="noticeCount" :max="99" :hidden="!noticeCount" class="badge-item">
        <div class="right-menu-btn flex-row align-center justify-center" @click="jumpToNoticeCenter">
          <i class="el-icon-message-solid" style="margin-right: 0;"></i>
          <span>通知中心</span>
        </div>
      </el-badge>

      <div v-if="userForm.status!==3" class="right-menu-btn flex-row align-center justify-center" @click="tutorialDialogVisible=true">
        <svg-icon icon-class="navbar-question" />
        <span>新手指导</span>
      </div>

      <el-dropdown ref="dropdown" class="avatar-container" trigger="click">
        <div class="avatar-wrapper flex-row align-center">
          <img src="@/assets/images/user-head.png" class="user-avatar">
          <div class="user-name">{{ userData.userName }}</div>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="userForm.status!==3" @click.native="handleLogOff">
            <span>申请注销</span>
          </el-dropdown-item>
          <el-dropdown-item v-if="userForm.status!==3" @click.native="handleChangePassword">
            <span>修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout">
            <span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-dialog title="" :visible.sync="tutorialDialogVisible" width="60%" top="5vh" :before-close="handleClose">
      <video ref="videoPlayer" width="100%" controls :src="videoUrl" />
    </el-dialog>
    <!-- 修改密码-->
    <el-dialog title="修改密码" :visible.sync="passDialogVisible" width="40%" top="5vh" :before-close="handlePassClose" :close-on-click-modal="false">
      <el-form ref="changeForm" :model="changeForm" :rules="changeRules" label-width="150px">
        <el-form-item label="请输入旧密码" prop="oldPassword">
          <el-input v-model="changeForm.oldPassword" type="password" show-password placeholder="请输入当前登录平台的密码" />
        </el-form-item>
        <el-form-item label="请输入新密码" prop="password">
          <el-input v-model="changeForm.password" type="password" show-password placeholder="请输入 8-16 位非空格字符（密码需含数字和大小写字母）" />
        </el-form-item>
        <el-form-item label="请再次输入新密码" prop="confirmPassword">
          <el-input v-model="changeForm.confirmPassword" type="password" show-password placeholder="请再次输入已填写的新密码" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handlePassClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </span>
    </el-dialog>
    <!-- 申请注销-->
    <el-dialog title="申请注销" :visible.sync="logoutDialogVisible" :before-close="handleLogoutClose" :close-on-click-modal="false">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules">
        <el-form-item>
          <span>感谢您曾经选择容智通平台。请您选择注销原因，帮助我们更好的完善体验：</span>
        </el-form-item>
        <el-form-item prop="reason">
          <el-radio v-for="item in reasonOptions" :key="item.value" v-model="ruleForm.reason" :label="item.value" border style="width:500px;margin-top:20px;margin-left:5px">{{ item.label }}</el-radio>
        </el-form-item>
        <el-form-item>
          <el-input v-model="remark" type="textarea" :rows="2" placeholder="请输入其他原因或反馈建议,不超过100字" @input="limitInput" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleLogoutClose()">取 消</el-button>
        <el-button type="primary" @click="handleLogoutSubmit()">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ErrorLog from '@/components/ErrLog'
import errLogStore from '@/store/errLog'
import notifyComp from './notify'
import { changePassWord, destoryToken, checkLeaveCondition, partPersonLeaveApply } from '@/api/login'

export default {
  components: {
    ErrorLog,
    // eslint-disable-next-line vue/no-unused-components
    notifyComp
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value.length !== this.changeForm.password.length) {
        callback(new Error('两次输入密码长度不一致'))
      } else if (value !== this.changeForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      changeForm: {
        oldPassword: '',
        password: '',
        confirmPassword: ''
      },
      ruleForm: {
        reason: ''
      },
      rules: {
        reason: [
          { required: true, message: '请选择注销原因后在提交！', trigger: 'blur' }
        ]
      },
      reasonOptions: [
        { label: '薪酬不理想', value: '10' },
        { label: '工作内容不满意', value: '11' },
        { label: '工作时间不自由', value: '12' },
        { label: '其他原因', value: '13' }
      ],
      changeRules: {
        oldPassword: [
          { required: true, message: '请您输入旧密码', trigger: 'blur' }
        ],
        password: [
          { required: true, trigger: 'blur', message: '请您输入密码' },
          { min: 8, max: 16, message: '请输入 8-16 位非空格字符（密码需含数字和大小写字母）', trigger: 'blur' },
          { validator: this.validateNoSpaces, trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validatePass, trigger: 'blur' }
        ]
      },
      log: errLogStore.state.errLog,
      userDataPage: {},
      userInfo: [],
      remark: '',
      userForm: {},

      tabularFault: false,
      localStorageKey: '',
      videoUrl: 'https://static.ainfinit.com/static/video/crowdsource-tutorial.mp4',
      tutorialDialogVisible: false,
      passDialogVisible: false,
      logoutDialogVisible: false
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'name', 'avatar', 'userData', 'elements']),
    userData() {
      return this.$store.state.user.userData
    },
    noticeCount() {
      return this.$store.state.permission.navbarNoticeCount
    }
  },
  watch: {
    stompConnect(val) {
      this.connect(val)
    }
  },
  created() {
    // 连接在app.vue中已经完成
    this.userDataPage = this.$store.state.user.userData || {}
    this.localStorageKey = this.userDataPage.phone
    const user = JSON.parse(localStorage.getItem('userData'))
    this.userForm = user
    this.$store.dispatch('GetNotice', { readFlag: 0 })
  },
  methods: {
    logout() {
      destoryToken().finally(res => {
        // 无论是否成功都执行以下方法
        this.$refs.dropdown.hide()
        this.common.SET_REDIRECT_PATH('loginOut')
        this.$store.dispatch('FedLogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      })
    },

    // 修改密码dialog
    handleChangePassword() {
      this.passDialogVisible = true
    },

    handleClose(done) {
      const video = this.$refs.videoPlayer
      if (video) {
        video.pause()
        video.currentTime = 0
      }
      done()
    },

    // 校验密码
    validateNoSpaces(rule, value, callback) {
      const hasTrailingSpace = value.endsWith(' ') // 检查是否有尾随空格
      const hasIntermediateSpace = /\s/.test(value) // 检查是否包含中间空格
      if (hasTrailingSpace || hasIntermediateSpace) {
        callback(new Error('密码中不允许有空格'))
      } else if (!/[A-Za-z]/.test(value) || !/[0-9]/.test(value) || !/[A-Z]/.test(value) || !/[a-z]/.test(value)) {
        callback(new Error('密码需含数字和大小写字母'))
      } else if (/[^A-Za-z0-9]/.test(value)) {
        callback(new Error('密码不可包含特殊字符'))
      } else {
        callback()
      }
    },

    // 关闭修改密码dialog
    handlePassClose() {
      this.passDialogVisible = false
      this.changeForm.oldPassword = ''
      this.changeForm.password = ''
      this.changeForm.confirmPassword = ''
    },

    // 修改密码
    handleSubmit() {
      this.$refs.changeForm.validate(valid => {
        if (valid) {
          if (this.changeForm.password !== this.changeForm.confirmPassword) {
            this.$message({
              message: '您输入的两次新密码不一致！请重新检查后在提交',
              type: 'warning'
            })
          } else {
            const data = {
              newPassword: this.changeForm.password,
              oldPassword: this.changeForm.oldPassword
            }
            changePassWord(data).then(res => {
              if (res.status === 200) {
                this.$message({
                  message: '您已成功重置密码，请重新登录',
                  type: 'success'
                })
                this.logout()
              }
            })
          }
        }
      })
    },

    // 验证是否复合注销要求
    handleLogOff() {
      const data = {
        userId: this.userForm.id
      }
      checkLeaveCondition(data).then(res => {
        if (res.data === true) {
          this.logoutDialogVisible = true
        } else {
          this.$message.warning('您不符合主动注销要求')
        }
      })
    },

    // 申请注销
    handleLogoutSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const data = {
            leaveSource: 1,
            leaveType: this.ruleForm.reason,
            remark: this.remark,
            userId: this.userForm.id
          }
          partPersonLeaveApply(data).then(res => {
            this.$message.success('您已成功提交注销申请，感谢您曾经选择容智通平台，再会！')
            this.handleLogoutClose()
            setTimeout(() => {
              window.location.reload()
            }, 2000)
          })
        }
      })
    },

    limitInput(e) {
      this.remark = e.substring(0, 100)
    },

    // 关闭注销dialog
    handleLogoutClose() {
      this.logoutDialogVisible = false
      this.$refs.ruleForm.resetFields()
      this.ruleForm = {}
      this.remark = ''
    },

    // 通知中心
    jumpToNoticeCenter() {
      this.$router.push({ path: '/system/notice' })
    },
  }
}
</script>

<style lang="scss">
.navbar-notify {
  width: 280px !important;
}

.el-icon-message-solid {
  margin-right: 20px;
  font-size: 18px;
  cursor: pointer;
}

.layout-navbar-topMenu {
  background-color: #ffff;
  border: none;
  color: #4b4b4b;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/variables.scss";

.layout-navbar-topMenu {
  // // width: 300px;
  // // height: 60px;
  // // line-height: 60px;
  // // border-radius: 0 !important;
  // // border-bottom: none !important;
  // // position: relative;
}

.right-menu {
  height: 100%;

  .badge-item {
    margin-right: 10px;

    .right-menu-btn {
      border-color: #248bff;
      background: #248bff;
      color: #ffffff;

      i {
        font-size: 16px;
      }

      span {
        color: #ffffff;
      }
    }

    ::v-deep .el-badge__content {
      right: 0;
      transform: translateY(-50%) translateX(50%);
      padding: 0 5px;
      line-height: 16px;
    }
  }

  .right-menu-btn {
    width: 106px;
    height: 36px;
    margin-left: 10px;
    border-radius: 8px;
    border: 1px solid #dcdfe6;
    cursor: pointer;

    span {
      margin-left: 4px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
  }

  .avatar-container {
    height: 100%;
    margin: 0 30px;
    cursor: pointer;

    .avatar-wrapper {
      height: 100%;

      .user-avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%px;
      }

      .user-name {
        flex: 1;
        max-width: 100px;
        margin: 0 10px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .el-icon-caret-bottom {
        font-size: 12px;
      }
    }
  }
}
</style>
